// extracted by mini-css-extract-plugin
module.exports = {"issue":"IssueList_issue_qbc-q","row":"IssueList_row_1vxgz","column":"IssueList_column_88AOT","dueDate":"IssueList_dueDate_35fF8","noData":"IssueList_noData_tlS4J"};